/*
 *
 * ChargebackDownloadPopup
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 15-Sep-2025
 */

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (component) => {
    switch (component) {
      case 'chargeback':
        return (
          <PortalMessage
            id='t.app.chargebackDownloadPopup.title.chargeback'
            defaultMessage='Download contestazioni (chargeback)'
          />
        )
      case 'refunds':
        return (
          <PortalMessage
            id='t.app.chargebackDownloadPopup.title.refunds'
            defaultMessage='Download di tutti i movimenti'
          />
        )
      default:
        return (
          <PortalMessage
            id='t.app.chargebackDownloadPopup.title.refunds'
            defaultMessage='Download di tutti i movimenti'
          />
        )
    }
  },
  date: (date) => (
    <PortalMessage id='t.app.chargebackDownloadPopup.date' defaultMessage='Del {date}' values={{ date }} />
  ),
  description: (
    <PortalMessage
      id='t.app.chargebackDownloadPopup.description'
      defaultMessage='La preparazione delle contestazioni da scaricare potrebbe richiedere qualche minuto. Al termine apparirà un file pronto per essere scaricato, dovrai cliccarci per salvarlo sul tuo dispositivo.'
    />
  ),
  downloadButton: (downloadType) => (
    <PortalMessage
      id='t.app.chargebackDownloadPopup.downloadButton'
      defaultMessage={`scarica ${downloadType}`}
      values={{ downloadType }}
    />
  )
}

export default formattedMessage
